import React from 'react';
import { useSelector } from 'react-redux';
import MuiBreadcrumbs from '@material-ui/core/Breadcrumbs';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import { Link } from '@reach/router';
import styled from 'styled-components';
import { TypographyNavLink } from '../../atoms/TypographyNavLink';

const StyledLink = styled(Link)`
    text-decoration: none;
    color: #4a4a4a;
`;

const Breadcrumb = () => {
    const migalha = useSelector(state => state.migalha);
    return (
        <MuiBreadcrumbs
            separator={<NavigateNextIcon fontSize='small' />}
            aria-label='breadcrumb'
        >
            {migalha.map(part => {
                if (part.rota) {
                    return (
                        <StyledLink to={part.rota} key={part.key}>
                            {part.nome}
                        </StyledLink>
                    );
                }
                return (
                    <TypographyNavLink color='textPrimary' key={part.key}>
                        {part.nome}
                    </TypographyNavLink>
                );
            })}
        </MuiBreadcrumbs>
    );
};

export { Breadcrumb };
